import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PycnometerProfileSummary } from '@models/pycnometer-profile.interface';

@Component({
  selector: 'app-pycnometer-profile-list',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule],
  templateUrl: './pycnometer-profile-list.component.html',
  styleUrl: './pycnometer-profile-list.component.scss'
})
export class PycnometerProfileListComponent {
  @Input() profiles: PycnometerProfileSummary[] = [];
  @Input() selectedId: number | null = null;

  @Output() profileSelected = new EventEmitter<PycnometerProfileSummary>();
  @Output() addClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<number>();

  readonly displayedColumns = ['name', 'actions'];

  onRowClick(profile: PycnometerProfileSummary): void {
    this.profileSelected.emit(profile);
  }

  onAddClick(): void {
    this.addClicked.emit();
  }

  onDeleteClick(profile: PycnometerProfileSummary, event: Event): void {
    event.stopPropagation();
    this.deleteClicked.emit(profile.id);
  }
}
